import { Card, CardContent, CardHeader } from "../Card";
import { Skeleton } from "../Skeleton";

export function ActivityFeedContentSkeleton() {
	return (
		<CardContent>
			<Skeleton className="h-4 w-[40px] mb-4" />
			<div className="mt-4 space-y-4">
				{Array.from({ length: 6 }).map((_, index) => (
					<div key={index} className="flex gap-3">
						<Skeleton className="h-8 w-8 rounded-full" />
						<div className="flex-1">
							<div className="flex items-center gap-2 mb-1">
								<Skeleton className="h-4 w-[100px]" />
								<Skeleton className="h-3 w-[60px]" />
							</div>
							<Skeleton className="h-4 w-full" />
							{index === 7 && (
								<div className="mt-2">
									<Skeleton className="h-12 w-full rounded-md" />
								</div>
							)}
						</div>
					</div>
				))}
			</div>
		</CardContent>
	);
}

export default function ActivityFeedSkeleton() {
	return (
		<Card className="flex-1">
			<CardHeader className="pb-2">
				<Skeleton className="h-5 w-[80px] mb-2" />
				<Skeleton className="h-8 w-full" />
			</CardHeader>
			<ActivityFeedContentSkeleton />
		</Card>
	);
}
